import React, { Component } from 'react';
import tryMe from '../../../helpers/tryMe';
import FormSubmit from '../../../containers/Forms/FormSubmit';
import SlateTextInput from '../../Shared/SlateTextInput';

export default class FormUserProfilePassword extends Component {
  UNSAFE_componentWillMount() {
    this.props.actions.setFormState({
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      dataErrors: {},
    });
  }

  showContactInfoError = () =>
    tryMe(this.props.state.dataErrors).contactInfo &&
    !this.props.state.contactInfo.email &&
    !this.props.state.contactInfo.phone;

  render() {
    const { actions, state, t, errorAction } = this.props;

    return (
      <form onKeyPress={actions.handleKeyPress}>
        <SlateTextInput
          name="currentPassword"
          type="password"
          autoComplete="current-password"
          placeholder={t('userProfile:currentPassword')}
          label={t('userProfile:currentPassword')}
          fullWidth={true}
          onChange={actions.handleChange}
          onBlur={actions.handleBlur}
          error={tryMe(state.dataErrors).currentPassword || ''}
          value={tryMe(state).currentPassword || ''}
        />

        <SlateTextInput
          name="newPassword"
          type="password"
          autoComplete="new-password"
          placeholder={t('userProfile:newPassword')}
          label={t('userProfile:newPassword')}
          fullWidth={true}
          onChange={actions.handleChange}
          onBlur={actions.handleBlur}
          error={tryMe(state.dataErrors).newPassword || ''}
          value={tryMe(state).newPassword || ''}
        />

        <SlateTextInput
          name="confirmNewPassword"
          type="password"
          autoComplete="new-password"
          placeholder={t('userProfile:confirmNewPassword')}
          label={t('userProfile:confirmNewPassword')}
          fullWidth={true}
          onChange={actions.handleChange}
          onBlur={actions.handleBlur}
          error={tryMe(state.dataErrors).confirmNewPassword || ''}
          value={tryMe(state).confirmNewPassword || ''}
        />

        {errorAction && (
          <div className="form-error form-error-action">{errorAction}</div>
        )}

        <FormSubmit
          title={t('userProfile:updatePassword')}
          handleSubmit={actions.handleSubmit}
          handleMouseDown={actions.handleMouseDown}
          entityName={state.entityName}
        />
      </form>
    );
  }
}
